import { SvgIcon } from '@mui/material';

export default function RoadDamage(): JSX.Element {
  return (
    <SvgIcon fontSize="small">
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="100.000000pt"
        height="103.000000pt"
        viewBox="0 0 900.000000 903.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <metadata>Created by potrace 1.10, written by Peter Selinger 2001-2011</metadata>
        <g
          transform="translate(0.000000,903.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="none"
        >
          <path
            d="M2705 8710 c-23 -11 -48 -33 -57 -48 -15 -25 -100 -297 -133 -427
-25 -98 -88 -320 -125 -440 -10 -33 -35 -121 -55 -195 -21 -74 -50 -178 -65
-230 -16 -52 -59 -203 -95 -335 -37 -132 -89 -314 -115 -405 -78 -267 -82
-283 -95 -335 -7 -27 -34 -122 -60 -210 -26 -88 -51 -173 -55 -190 -4 -16 -17
-65 -29 -107 -11 -43 -21 -95 -21 -116 0 -80 76 -147 156 -139 28 3 148 57
364 166 178 88 327 161 331 161 26 0 2 -29 -246 -301 -76 -85 -189 -208 -250
-274 -217 -234 -349 -380 -377 -419 -32 -45 -38 -107 -14 -159 8 -18 33 -77
56 -132 23 -55 47 -113 55 -130 20 -47 81 -191 201 -478 59 -142 59 -153 2
-180 -18 -8 -127 -59 -243 -112 -115 -54 -246 -115 -290 -135 -418 -197 -383
-178 -417 -227 -15 -21 -32 -58 -38 -83 -6 -25 -26 -94 -44 -155 -19 -60 -41
-137 -50 -170 -16 -59 -59 -210 -130 -455 -20 -69 -46 -159 -57 -200 -12 -41
-46 -158 -75 -260 -30 -102 -61 -212 -70 -245 -9 -33 -31 -109 -49 -170 -48
-160 -80 -272 -99 -340 -26 -95 -64 -228 -113 -395 -25 -85 -48 -164 -50 -175
-3 -11 -21 -71 -39 -134 -19 -62 -34 -134 -34 -160 0 -56 27 -103 72 -128 32
-17 207 -18 4184 -18 l4151 0 37 29 c41 31 66 78 66 123 0 15 -9 60 -20 98
-32 112 -95 330 -133 460 -19 66 -46 161 -60 210 -38 136 -155 545 -167 585
-6 19 -28 96 -50 171 -21 75 -49 174 -63 220 -14 46 -37 125 -50 174 -14 50
-37 131 -52 180 -31 104 -68 234 -91 320 -9 33 -21 74 -26 90 -5 17 -22 75
-38 130 -15 55 -40 141 -55 190 -14 50 -38 131 -52 180 -14 50 -34 117 -44
151 -36 113 -125 162 -212 117 -33 -17 -136 -97 -677 -530 -173 -139 -321
-253 -327 -253 -7 0 -13 4 -13 9 0 8 89 152 242 389 20 31 62 98 93 147 181
290 175 278 175 323 0 75 -42 127 -135 165 -45 18 -404 172 -451 192 -16 8
-68 30 -114 50 -108 46 -116 52 -94 77 10 10 29 24 43 32 14 7 170 98 346 201
176 103 390 228 475 277 85 48 170 104 189 122 43 43 51 105 26 192 -9 32 -27
97 -40 144 -12 47 -48 173 -79 280 -31 107 -63 220 -71 250 -8 30 -38 134 -66
230 -28 96 -57 198 -64 225 -8 28 -23 84 -35 125 -12 41 -27 98 -34 125 -8 28
-26 91 -41 140 -15 50 -43 146 -61 215 -19 69 -68 242 -109 385 -40 143 -88
312 -105 375 -18 63 -45 158 -60 210 -37 126 -61 208 -70 245 -20 77 -129 462
-170 596 -21 69 -54 110 -103 128 -20 8 -577 11 -1815 11 -1766 0 -1787 0
-1827 -20z m3468 -292 c9 -7 27 -53 41 -103 13 -49 36 -130 50 -180 14 -49 33
-117 42 -150 9 -33 29 -100 44 -150 32 -101 71 -238 105 -365 12 -47 44 -157
70 -245 26 -88 53 -182 60 -210 16 -62 87 -313 119 -420 13 -44 33 -114 45
-155 35 -125 89 -313 127 -442 20 -68 40 -136 44 -153 4 -16 17 -64 28 -105
20 -72 34 -121 115 -395 19 -66 46 -162 59 -214 l23 -93 -32 -27 c-17 -14
-148 -93 -290 -175 -273 -158 -369 -214 -630 -370 -90 -53 -166 -96 -169 -96
-3 0 -37 -20 -74 -45 -94 -63 -119 -120 -86 -199 25 -60 29 -62 613 -312 98
-42 201 -85 228 -97 28 -11 58 -29 69 -38 18 -17 18 -19 -13 -71 -17 -29 -54
-87 -81 -128 -27 -41 -61 -95 -76 -120 -22 -37 -167 -265 -319 -502 -16 -26
-55 -87 -86 -135 -30 -48 -103 -162 -161 -253 -203 -319 -206 -325 -172 -397
34 -70 119 -108 185 -80 19 8 93 61 164 118 173 137 815 651 1145 916 173 139
272 212 285 211 19 -3 39 -62 111 -323 7 -27 22 -81 33 -120 30 -111 177 -625
226 -790 24 -82 58 -202 76 -265 40 -143 71 -255 104 -365 31 -105 70 -242 79
-275 13 -51 35 -129 86 -305 69 -236 71 -247 58 -262 -8 -11 -742 -13 -3883
-13 -3359 0 -3874 2 -3885 14 -13 16 -1 67 96 396 30 102 61 210 69 240 8 30
31 111 51 180 20 69 47 166 61 215 14 50 37 128 50 175 13 47 53 184 87 305
35 121 80 281 100 355 21 74 44 153 51 175 8 22 32 103 53 180 22 77 52 185
67 240 15 55 34 109 42 121 7 12 50 38 96 59 45 21 142 67 216 102 73 34 135
63 136 63 2 0 56 25 120 55 63 30 117 55 119 55 2 0 66 30 142 66 77 36 158
75 182 86 24 11 54 36 67 56 48 70 45 80 -175 593 -110 257 -200 474 -200 482
0 16 21 40 220 258 191 208 289 316 435 479 76 85 166 184 199 220 34 36 100
108 147 160 47 52 153 168 235 258 200 220 216 250 173 339 -24 49 -77 83
-131 83 -23 0 -197 -82 -586 -276 -410 -204 -556 -273 -566 -265 -10 8 -2 45
36 178 27 93 55 191 63 218 26 98 52 192 98 350 26 88 54 185 62 215 25 91 63
225 91 318 14 48 37 128 51 177 13 50 32 115 40 145 9 30 26 89 38 130 13 41
40 136 60 210 21 74 49 173 62 220 14 47 35 122 48 168 13 46 29 90 35 98 11
12 230 14 1639 14 1286 0 1631 -3 1644 -12z"
          />
          <path
            d="M4471 7983 c-18 -9 -45 -34 -60 -56 l-26 -41 -2 -375 c-1 -207 2
-396 7 -421 6 -33 18 -54 49 -82 36 -34 45 -38 95 -38 48 0 60 4 92 32 20 17
40 42 45 55 5 13 9 206 9 429 l1 406 -23 34 c-25 37 -90 74 -129 74 -13 0 -39
-8 -58 -17z"
          />
          <path
            d="M4464 6511 c-17 -10 -42 -34 -55 -53 l-24 -33 0 -400 c0 -448 0 -447
68 -496 70 -50 152 -35 202 38 l25 38 0 410 c0 391 -1 411 -20 443 -41 68
-132 92 -196 53z"
          />
          <path
            d="M4459 5044 c-14 -9 -36 -32 -50 -52 l-24 -36 0 -405 c0 -400 0 -407
22 -441 29 -47 71 -70 128 -70 52 0 90 18 120 58 19 26 20 45 23 437 2 293 -1
417 -9 437 -6 16 -27 42 -46 58 -28 25 -42 30 -86 30 -30 0 -63 -7 -78 -16z"
          />
          <path
            d="M4473 3586 c-17 -8 -44 -34 -60 -57 l-28 -43 0 -405 c0 -400 0 -407
22 -441 60 -96 197 -93 255 6 16 28 18 64 18 433 1 441 0 448 -60 491 -38 27
-106 34 -147 16z"
          />
          <path
            d="M4475 2120 c-37 -15 -77 -68 -86 -112 -4 -24 -7 -212 -5 -419 4 -413
5 -415 66 -459 68 -49 159 -31 206 40 l25 37 -1 408 c0 454 1 445 -70 492 -34
24 -96 30 -135 13z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
